export default __webpack_public_path__ + "static/media/PlayStore.2c4f9f77.png";